/**
 * module-gating.ts — shared helper extracted from `ProductSearchPicker.tsx` (F1,
 * plan „shared frontend foundations for the product-picker modal").
 *
 * Module-gating statuses treated as "tenant can't see this" rather than a real
 * failure — callers typically degrade a list query to an empty result on
 * 402/403 instead of surfacing `isError` (see `ProductSearchPicker`'s products
 * query and `useWarehouses` for the canonical usage pattern).
 */

import { isAxiosError } from 'axios';

export function isModuleGatingError(err: unknown): boolean {
  const status = isAxiosError(err) ? err.response?.status : undefined;
  return status === 402 || status === 403;
}

/**
 * `staleTime` shared by module-gated list queries (`useWarehouses`,
 * `ProductSearchPicker`'s products query, and the upcoming picker modal) —
 * extracted so the "how fresh does this gated catalog need to be" decision
 * lives in one place instead of being duplicated per consumer.
 */
export const MODULE_GATED_LIST_STALE_TIME_MS = 15_000;
